<template>
  <div id="btnServiceMenu">
    <v-menu
      v-model="menu"
      offset-x
      min-width="800px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnServiceMenu"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
        >
          Додати Сервіс
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="pb-0">
          <ServiceSelect
            v-model="service"
            @input="onSelect"
          />

          <v-row>
            <v-col xs6>
              <DecimalEditor
                v-model="price"
                :value="amount"
                :disabled="saleOptions === serviceSaleOptions.WITH_VAT.label"
                label="Сума"
                scale="2"
                :hide-details="false"
                class="mr-1"
                :error-messages="$v.price.$error ? errors.ONLY_POSITIVE : []"
                @input="$v.price.$touch()"
              />
            </v-col>
            <v-col xs6>
              <DecimalEditor
                v-model="priceWithVAT"
                :value="amountWithVAT"
                :disabled="saleOptions === serviceSaleOptions.WITHOUT_VAT.label"
                label="Сума з ПДВ"
                scale="2"
                :hide-details="false"
                class="ml-1"
                :error-messages="
                  $v.priceWithVAT.$error ? errors.ONLY_POSITIVE : []
                "
                @input="$v.priceWithVAT.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              xs6
              class="py-0"
            >
              <DecimalEditor
                v-model="quantity"
                label="Кількість"
                :error-messages="$v.quantity.$error ? errors.ONLY_POSITIVE : []"
                :hide-details="false"
                @input="$v.quantity.$touch()"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="saleOptions !== serviceSaleOptions.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            class="mt-n4"
            @click="ok"
          >
            {{
              saleOptions === serviceSaleOptions.WITH_VAT.label
                ? "З ПДВ"
                : "Без ПДВ"
            }}
          </v-btn>

          <v-btn
            v-if="saleOptions === serviceSaleOptions.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            class="mt-n4"
            @click="ok(false)"
          >
            Без ПДВ
          </v-btn>

          <v-btn
            v-if="saleOptions === serviceSaleOptions.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            class="mt-n4"
            @click="ok(true)"
          >
            З ПДВ
          </v-btn>

          <v-btn
            text
            class="mt-n4"
            @click="cancel"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ServiceSelect from "../../catalogs/services/ServiceSelect.vue";
import DecimalEditor from "../../../components/DecimalEditor.vue";
import * as servicesApi from "../../../backend/servicesApi.js";
import serviceSaleOptions from "../../../helpers/serviceSaleOptions.js";
import { ERRORS } from "@/helpers";
import { minValue } from "vuelidate/lib/validators";

export default {
  components: {
    DecimalEditor,
    ServiceSelect,
  },
  data: () => ({
    menu: false,
    selected: null,
    saleOptions: null,
    service: null,
    quantity: 1,
    price: 0,
    priceWithVAT: 0,
  }),

  validations: {
    quantity: {
      minValue: minValue(1),
    },
    price: {
      minValue: minValue(0),
    },
    priceWithVAT: {
      minValue: minValue(0),
    },
  },

  computed: {
    amount() {
      if (!this.price) {
        return 0;
      }
      return this.price * this.quantity;
    },
    amountWithVAT() {
      if (!this.priceWithVAT) {
        return 0;
      }
      return this.priceWithVAT * this.quantity;
    },
    serviceSaleOptions() {
      return serviceSaleOptions;
    },
    errors() {
      return {
        ONLY_POSITIVE: [ERRORS.ONLY_POSITIVE],
      };
    },
  },
  watch: {
    saleOptions: {
      handler(val) {
        if (val === null) {
          this.saleOptions = this.serviceSaleOptions.BOTH_VAT.label;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async onSelect() {
      if (this.service?.id) {
        this.selected = await servicesApi.getService(this.service.id);
        this.saleOptions = this.selected.saleOptions;
        this.price = this.selected.amount;
        this.priceWithVAT = this.selected.amountWithVAT;
        this.selected.id = this.service.id;
      }
    },
    ok(withVAT) {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.$emit("input", {
        id: this.selected.id,
        type: "service",
        title: this.selected.title,
        amount:
          this.saleOptions === this.serviceSaleOptions.BOTH_VAT.label
            ? withVAT
              ? this.amountWithVAT
              : this.amount
            : this.saleOptions === this.serviceSaleOptions.WITH_VAT.label
              ? this.amountWithVAT
              : this.amount,
        recurrence: {
          id: this.selected.recurrence.id,
          title: this.selected.recurrence.title,
        },
        quantity: this.quantity,
      });
      this.cancel();
    },
    cancel() {
      this.selected = null;
      this.price = 0;
      this.priceWithVAT = 0;
      this.saleOptions = this.serviceSaleOptions.BOTH_VAT.label;
      this.menu = false;
      this.service = null;
      this.quantity = 1;
    },
  },
};
</script>
